import { Moment } from "moment";
import moment from "moment-timezone";
import { RootState } from "redux/store";
import { useSelector } from "react-redux";

export const useDateTime = () => {
  const tenantTimezone = useSelector((state: RootState) => state.app.tenantTimezone);

  const formatDateTime = (date: Date | undefined): string | undefined => {
    if (!date) return undefined;
    
    let momentDate: Moment = moment(date);

    let formatted: string = "";

    if (tenantTimezone) momentDate = momentDate.tz(tenantTimezone);
    formatted = `${momentDate.format("MM/DD/YYYY hh:mm A")} ${momentDate.zoneAbbr()}`;

    return formatted;
  };

  return formatDateTime;
};
